import { getStringWidth } from '@visx/text';
import { useIntl } from '@leagueplatform/locales';

// Visx automatically adds a 36px offset to the left axis label
const DEFAULT_VISX_LEFT_AXIS_TICK_OFFSET = 36;

// Calculates the pixel width of the formatted yMax value and determine it's offset.
export function useGetLeftAxisLabelOffset(yMax: number) {
  const { formatNumber } = useIntl();

  return (
    (getStringWidth(formatNumber(yMax)) ?? 0) +
    DEFAULT_VISX_LEFT_AXIS_TICK_OFFSET
  );
}
